<template>
  <div class="inquiry-tem big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">问诊单模板</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div class="search-item">
            <div class="item">
              <span>医生姓名</span>
              <el-input
                v-model="searchCondition.doctor_name"
                placeholder="请输入"
                style="width: 160px; margin: 0 12px 0 5px"
                @input="searchClick"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机</span>
              <el-input
                v-model="searchCondition.phone"
                placeholder="请输入"
                style="width: 160px; margin: 0 12px 0 5px"
                @input="searchClick"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>模板名称</span>
              <el-input
                v-model="searchCondition.inquiry_sheet_name"
                placeholder="请输入"
                style="width: 160px; margin: 0 12px 0 5px"
                @input="searchClick"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>编辑人员</span>
              <el-input
                v-model="searchCondition.edit_name"
                placeholder="请输入"
                style="width: 160px; margin: 0 12px 0 5px"
                @input="searchClick"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>指定问诊单</span>
              <el-radio-group
                v-model="searchCondition.is_default"
                @change="searchClick"
                style=" margin: 0 12px 0 5px"
              >
                <el-radio :label="-1">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="info"
              size="medium"
              style="background-color: #eceff2;color: #747981;margin-right: 20px;"
              @click="searchClick"
            >查询</el-button>
          </div>
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addTemplateClick"
              :disabled="module_id_array[0] ? !module_id_array.includes('625') : false"
            >新增模板</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="inquiryTableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >

            <el-table-column
              v-for="(item, index) in headerTable"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'desc'">
                  {{ scope.row[item.prop] | ellipsis(50) }}
                </div>
                <div
                  v-if="item.prop == 'doctor_name'"
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >
                  {{ scope.row.doctor_name}}
                </div>
                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :disabled="module_id_array[0] ? !module_id_array.includes('624') : false"
                  @click="editorClick(scope.row)"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 选择医生，新增模板 -->
    <doctor-template
      v-if="addTemplate"
      @closeShow="closeShow"
    ></doctor-template>
  </div>
</template>

<script>
import Pagination from '../../../components/Pagination/index.vue';
import DoctorTemplate from './components/DoctorTemplate.vue';
import inquiryTemplate from '../../../api/inquiryTemplate';
import DocMsg from '../../../components/common/DocMsg.vue';
import dayjs from 'dayjs';
export default {
  components: {
    Pagination,
    DoctorTemplate,
    DocMsg
  },
  data() {
    return {
      addTemplate: false,
      searchCondition: {
        doctor_name: '',
        phone: '',
        inquiry_sheet_name: '',
        edit_name: '',
        is_default: -1
      },
      headerTable: [
        {
          label: '医生姓名',
          prop: 'doctor_name'
        },
        {
          label: '手机号',
          prop: 'phone'
        },
        {
          label: '医院',
          prop: 'hospital'
        },
        {
          label: '模板名称',
          prop: 'inquiry_sheet_name'
        },
        {
          label: '问诊单作用说明',
          prop: 'desc'
        },
        {
          label: '最后编辑时间',
          prop: 'update_time'
        },
        {
          label: '编辑人员',
          prop: 'edit_name'
        }
      ],
      inquiryTableData: [],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    }
  },
  filters: {
    ellipsis(value, limit) {
      if (!value) return '';
      if (value.length > limit) {
        return value.slice(0, limit) + '...';
      }
      return value;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let params = Object.assign(this.searchCondition, this.pagination);
      inquiryTemplate.getInquirySheetLists(params).then((res) => {
        let { data } = res;

        this.inquiryTableData = data.list.map((item) => {
          item.update_time = dayjs
            .unix(item.update_time)
            .format('YYYY-MM-DD HH:mm');
          return item;
        });
        this.totalNum = data.total;
      });
    },
    searchClick() {
      this.pagination.page = 1;
      this.getList();
    },
    editorClick(row) {
      console.log(row);
      this.$router.push({
        path: '/home/template/addOrEditorTem',
        query: {
          is_add: 1,
          doctor_id: row.doctor_id,
          hospital: row.hospital,
          phone: row.phone,
          doctor_name: row.doctor_name,
          inquiry_sheet_id: row.inquiry_sheet_id,
          inquiry_sheet_name: row.inquiry_sheet_name
        }
      });
    },
    // 新增模板
    addTemplateClick() {
      this.addTemplate = true;
    },
    closeShow() {
      this.addTemplate = false;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.inquiry-tem {
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    .search-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        padding: 4px 0;
      }
    }
  }
}
</style>